export default "__VITE_ASSET__C5OVCMsk__"